<template>
    <div class="uk-flex uk-flex-column h-100" style="max-height:450px">
        <div class="uk-flex-1">
            <div class="uk-flex uk-flex-between uk-margin-small-top uk-margin-small-bottom">
                <div>{{ $t('integration.detailed_information') }}</div>
                <div class="cursor-pointer color-theme"
                    @click="carrierDetail(info.carrier.id, info.carrier.keycode, info.carrier.typeId)">{{
                        $t('integration.more') }}>></div>
            </div>
        </div>
        <div class="uk-flex " v-if="info" style="height:calc(100% - 20px)">
            <div style="height:calc(100%);width:50%;" class="border">
                <div class="uk-text-center carrier-img-title uk-position-relative"
                    style="border-bottom:1px #ccc solid; padding: 10px 0;font-weight: 600;">
                    {{ info.carrier.keycode }}

                    <span class="uk-position-absolute" style="right: 10px;top:7px">
                        <AlarmSwitch :alarmSwitch="info.carrier.alarm_switch" :carrier-ids="[info.carrier.id]"
                            :scene-id="info.carrier.scene_id" :carrierType="info.carrier.type_id"
                            :related="info.carrier.alarm_bind" :getList="refreshAlarm"></AlarmSwitch>
                    </span>
                </div>
                <div style="padding:5px 10px;height: calc(100% - 50px);" class="">
                    <div class="h-100">
                        <CarrierInfoImg :carrier="info.carrier" :tab.sync="info.carrier.tab"></CarrierInfoImg>
                    </div>
                </div>
            </div>

            <div class="uk-flex-1 h-100 border" style="overflow-y: auto;border-left-color: transparent;">

                <EquiInfo :detail-info="info"></EquiInfo>
            </div>
        </div>
        <AlarmSwitchDialog></AlarmSwitchDialog>
    </div>
</template>

<script>
import { carrierDetail } from '@/utils/winDetail';
import CarrierInfoImg from '@/pages/dataBoard/MonitoringPoint/component/DisplayArea/component/component/CarrierInfoImg';
import AlarmSwitch from '@/components/AlarmSwitch/AlarmSwitch';
import AlarmSwitchDialog from '@/components/AlarmSwitch/AlarmSwitchDialog';
import EquiInfo from '@/pages/home/component/Map/component/equiInfo';
export default {
    props: ['info'],
    watch: {
        info() {
            this.$set(this.info.carrier, 'tab', 0);
        }
    },
    methods: {
        refreshAlarm({ event }) {
            this.info.carrier.alarm_switch = event;
        },
        async carrierDetail(carrierId, carrierName, carrierType) {
            if (!this.info || !this.info.carrier) {
                return;
            }
            try {
                await carrierDetail(carrierId, carrierName, carrierType);
            } catch (e) {
                console.error('[UniversalDetail] carrierDetail error:', e);
            }
        }
    },
    components: {
        CarrierInfoImg,
        AlarmSwitch,
        AlarmSwitchDialog,
        EquiInfo
    }
};
</script>
